<template>
  <div class="company-contain">
    <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px;">
      <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
        <div class="loading-img"></div>
      </div>
    </div>

    <div class="search-company-box">   
      <!-- 十大股东 -->
      <div class="pledge-box1-top" v-if="holders.length > 0">
        <h3>{{ holders[0].date }}</h3> 
      </div>
      <div class="Single-list-main" v-if="holders.length > 0"> 
        <ul class="Single-list-box" v-for="item in holders">
          <li class="list-w">
            <p class="date">机构或基金名称</p> 
            <p class="time">{{ item.name }}</p>
          </li>
          <li>
            <p class="date">持有数量</p> 
            <p class="time">{{ item.quantity | money }}</p>
          </li>
          <li>
            <p class="date">持股变化</p> 
            <p class="time">{{ item.quantity | money }}</p>
          </li>
          <li>
            <p class="date">占流通股比例(%)</p> 
            <p class="time">{{ parseFloat(item.ratio) }}</p>
          </li> 
          <li>
            <p class="date">实际增减持(%)</p> 
            <p class="time">{{item.changeqty / item.quantity * 100 | two | kong}}<template v-if="item.quantity && item.changeqty">%</template></p>
          </li>   
        </ul>   
      </div>  

      <!-- 公司股东历史 -->
      <div class="pledge-box1"> 
        <div class="product-head">
          <!-- <h3 class="">公司股东历史</h3> -->
          <span class="text">公司股东历史</span>

          <div class="Quarterly-Report" v-if="history.dataTypes.length">
            <div class="head-title" @click="showDropdown">
              <template v-if="history.dateTyp == ''">全 部</template>
              <template v-else>{{ history.dateTyp }}</template>
              <span class="close-bot"></span>
            </div>
            <ul class="menu-lanmu" :style="{'display': dropdownMenu ? 'block' : 'none'}">  
              <li v-if="history.dateTyp != ''" @click="filterHistory(h)">
                <a href="javascript::">全 部</a>
              </li>
              <template v-for="h in history.dateTypes" track-by="$index">
                <li v-if="history.dateTyp != h.datestr" @click="filterHistory(h)">
                  <a href="javascript::">{{ h.datestr }}</a>
                </li>
              </template>
            </ul>
          </div>
        </div>

        <div class="Single-list-main" v-if="history.lists.length">
          <ul class="Single-list-box" v-for="(index, h) in history.lists" track-by="$index" v-show="index >= ((history.page-1)*10) && index < (history.page*10)"> 
          <!-- <ul class="Single-list-box" v-for="(index, h) in history.lists" track-by="$index">  -->
            <li class="list-w"><p class="date">机构或基金名称</p><p class="time">{{ h.name }}</p></li> 
            <li><p class="date">持有数量</p><p class="time">{{ h.quantity | money }}</p></li>
            <li><p class="date">持股变化</p><p class="time">{{h.changeqty | money | nullVal}}</p></li>
            <li>
              <p class="date">占流通股比例(%)</p>
              <p class="time">{{parseFloat(h.ratio)}}</p>
            </li> 
            <li>
              <p class="date">实际增减持(%)</p>
              <p class="time">
                {{h.changeqty / h.quantity * 100 | two | kong}}
                <template v-if="h.quantity && h.changeqty">%</template>
              </p>
            </li> 
            <li><p class="date">公告日期</p><p class="time">{{ h.date }}</p></li> 
          </ul> 
        </div> 
        <div class="cop-pledge-page" v-if="history.lists.length"> 
          <span class="Previous-page" v-if="history.page > 1" @click="history.page--">上一页</span>
          <span class="menu-page"><span style="color: #3270ad">{{ history.page }}</span>/{{ history.totalPage }} </span>
          <span class="lower-page" v-if="history.page < history.totalPage" @click="history.page++">下一页</span> 
        </div>

        <div class="Single-list-main" v-if="!history.lists.length && !loading"> 
          <div class="Block-trade-no">暂无数据</div>
        </div>  
      </div> 
    </div>
  </div>

  <!--微信绑定弹框-->
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind">
    <div class="binding-content">
      <a class="binding-logo"></a>
      <div class="binding-text">
        立即绑定IBDATA账号<br/>成为金融分析高手
      </div>
      <div class="binding-bot">
        <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
        <a class="binding-btn" @click="goBindPage">立即绑定</a>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade in" v-show="tipGoBind"></div>
  <!-- / 微信绑定弹框-->
</template>

<script>
  import { alert, apiUrl, downloadURL } from '../../helper'
  import $ from 'jquery'
  import userMix from '../../common/userMix'
  import searchMix from '../../common/searchMix'
  import comSearchMix from '../../common/comSearchMix'
  import companyMix from '../../common/companyMix'
  import wxshareMix from '../../common/wxshareMix'

  export default {
    name: 'InvestView',
    mixins: [userMix, searchMix, comSearchMix, companyMix, wxshareMix],
    data () {
      return {
        holders: [],
        relations: [],
        history: {
          lists: [],
          originLists: [],
          dateTypes: [],
          dateTyp: '',
          page: 1,
          perPage: 10,
          total: 0,
          totalPage: 0,
        },
        sort: '',
        desc: '',
        dropdownMenu: false,
      }
    },
    route: {
      data({to}) {

        if (!this.currentuser) {
          console.log('909090');
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          if (this.wxcode) {
            this.wxlogin(this.wxcode)
          } else {
            console.log('profile');
            this.getProfile(to.query.share)
          }
        }

        if (this.currentuser) { 
          this.queryParam = to.query;
          this.companycode = to.query.companycode;
          this.stype = to.query.stype;

          // 微信签名 分享
          let title = decodeURIComponent(to.query.desc);
          let desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
          document.title = title;
          this.getwxsign()    // 微信签名
          this.shareCompany(title, desc);
          
          this.setSelectedTab();
          this.getGuDong();
          this.getHistory();
        }
      }
    },
    methods: {
      // 十大股东
      getGuDong: function() {
        this.loading = false;

        let query = {};
        query.code = this.companycode;
        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid
     
        $.ajax({
          url: apiUrl('/V1.0.0/company/gudong'),
          method: 'post',
          dataType: 'json',
          // data: JSON.stringify({'code': this.companycode})
          data: JSON.stringify(query)
        }).done((response) => {

          this.loading = false;
          if (response.status === 0) {
            this.holders = response.data.holders;
            this.holders.sort(function (a, b) {return b.quantity - a.quantity});
          } else {
            alert(response.description);
          }
          
        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })
      },
      // 变动历史
      getHistory: function () {
        this.loading = true;

        let query = {};
        query.code = this.companycode;
        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid

        $.ajax({
          url: apiUrl('/V1.0.0/company/gudonghist'),
          method: 'post',
          dataType: 'json',
          // data: JSON.stringify({'code': this.companycode})
          data: JSON.stringify(query)
        }).done((response) => {
          
          this.loading = false;
          if (response.status === 0) {
            this.history.lists = response.data;
            this.history.originLists = response.data;
            this.history.total = response.data.length;
            this.history.totalPage = Math.ceil(this.history.total / this.history.perPage);

            function formatDate(date) {
              let y = date.split('-')[0];
              let m = date.split('-')[1];
              let d = date.split('-')[2];

              if (m == '03') {
                return y + '年一季报';
              } else if (m == '06') {
                return y + '年半年报';
              } else if (m == '09') {
                return y + '年三季报';
              } else if (m == '12') {
                return y + '年年报';
              }
            }

            let tmp = {};
            for (let h of this.history.lists) {
              if (!h.changeqty) {
                h.changeqty = 0;
              }

              if (!tmp[h.date]) {
                tmp[h.date] = true;
                this.history.dateTypes.push({'date': h.date, 'datestr': formatDate(h.date)});
              }
            }

            if (this.history.dateTypes.length > 0) {
              this.history.dateTypes.sort((a, b) => {
                return Date.parse(b.date) - Date.parse(a.date);
              });
            }
          } else {
            alert(response.description);
          }
        }).fail((response) => {
          this.loading = false;
          alert('请求失败');
        })
      },
      // 排序
      historyTableSort: function(type) {
        this.sort = type;

        if (type == 'date') {
          if (this.desc == '' || this.desc == 2) {
            this.desc = 1;
            this.history.lists.sort((a, b) => {
              return Date.parse(b.date) - Date.parse(a.date);
            });
          } else if (this.desc == 1) {
            this.desc = 2;
            this.history.lists.sort((a, b) => {
              return Date.parse(a.date) - Date.parse(b.date);
            });
          }
        }

        if (type == 'ratio') {
          if (this.desc == '' || this.desc == 2) {
            this.desc = 1;
            this.history.lists.sort((a, b) => {
              return parseFloat(b.ratio) - parseFloat(a.ratio);
            });
          } else if (this.desc == 1) {
            this.desc = 2;
            this.history.lists.sort((a, b) => {
              return parseFloat(a.ratio) - parseFloat(b.ratio);
            });
          }
        }

        if (type == 'changeqty') {
          if (this.desc == '' || this.desc == 2) {
            this.desc = 1;
            this.history.lists.sort((a, b) => {
              return parseFloat(b.changeqty) - parseFloat(a.changeqty);
            });
          } else if (this.desc == 1) {
            this.desc = 2;
            this.history.lists.sort((a, b) => {
              return parseFloat(a.changeqty) - parseFloat(b.changeqty);
            });
          }
        }

        if (type == 'quantity') {
          if (this.desc == '' || this.desc == 2) {
            this.desc = 1;
            this.history.lists.sort((a, b) => {
              return parseFloat(b.quantity) - parseFloat(a.quantity);
            });
          } else if (this.desc == 1) {
            this.desc = 2;
            this.history.lists.sort((a, b) => {
              return parseFloat(a.quantity) - parseFloat(b.quantity);
            });
          }
        }
      },
      // 筛选
      filterHistory: function(h) {
        this.loading = true;
        this.dropdownMenu = false;
        let arr = [];
        if (h) {
          this.history.dateTyp = h.datestr;

          let resource = this.history.originLists;
          for (let item of resource) {
            if (item.date == h.date) {
              arr.push(item);
            }
          }

        } else {
          this.history.dateTyp = '';
          arr = this.history.originLists;
        }

        this.history.lists = arr;
        this.history.page = 1;
        this.history.total = arr.length;
        // this.history.totalPage = Math.ceil(arr.length / this.history.perPage);

        let that = this;
        setTimeout(function() {
          that.loading = false;
        }, 500);
      },
      showDropdown: function() {
        this.dropdownMenu = this.dropdownMenu ? false : true;
      },
      hideDropmenu: function(e) {
        let _con = $('.keyword-down-c')
        // 判断点击是否发生在空白区域
        if (!_con.is(e.target) && _con.has(e.target).length === 0) {
          this.dropdownMenu = false;
        }
      },
    }
  }
</script>

<style scoped>
  /* 加载 */
  .loading-box {
    top: 43% !important;
  }
  .loading-img {
    width: 35px;
    height: 35px;
    background-image: url('../../../static/images/loading2.gif');
    background-size: cover;
  }

  .Quarterly-Report .head-title {
    display: block;
  }
</style>


/** WEBPACK FOOTER **
 ** GuDongTop10.vue?0bae0fc0
 **/